import { footerLinks } from '@/mocks/home';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href === '#footer') {
      e.preventDefault();
      return;
    }
    if (window.location.pathname === '/') {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="font-heading text-lg font-semibold text-white mb-4">
              8848影院
            </h3>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              你的全集追剧第一站。国产剧、韩剧、美剧全集高清在线观看，无需注册，打开即看。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">
              剧集分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.categories.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                    onClick={(e) => handleClick(e, item.href)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.quickLinks.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                    onClick={(e) => handleClick(e, item.href)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">
              合作伙伴
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.partners.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                    onClick={(e) => handleClick(e, item.href)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 8848影院. 本站内容仅供学习交流，请于下载后24小时内删除。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                免责声明
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                隐私政策
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}